import BaseAPI from "../api";

const path: string = "/meeting-room";


export class MeetingRoomApi extends BaseAPI {
    static list(query: any): Promise<any> {
        return this.api.get(`${path}`, {
            params: { ...query },
        });
    }
    static myList(query: any): Promise<any> {
        return this.api.get(`/my-meeting`, {
            params: { ...query },
        });
    }
    static listCoordinators(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/coordinators`, {
            params: { ...query },
        });
    }
    static download_meeting_agendas(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/download_meeting_agendas`, {
            params: { ...query },
            responseType: "arraybuffer",
        });
    }
    static listParticipants(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/participants`, {
            params: { ...query },
        });
    }
    static listAgendas(id: any): Promise<any> {
        return this.api.get(`${path}/${id}/agendas`);
    }
    static resolution(id: any): Promise<any> {
        return this.api.get(`${path}/${id}/resolution`);
    }
    static getAgendas(id: any, id_agenda: any): Promise<any> {
        return this.api.get(`${path}/${id}/agendas/${id_agenda}`);
    }
    static getParticipant(id: any, id_participant: any): Promise<any> {
        return this.api.get(`${path}/${id}/participants/${id_participant}`);
    }
    static post(body: any): Promise<any> {
        return this.api.post(`${path}`, body);
    }
    static postResolution(body: any,id:any): Promise<any> {
        return this.api.post(`${path}/${id}/resolution`, body);
    }
    static copy(id:any): Promise<any> {
        return this.api.post(`${path}/${id}/copy`);
    }
    static send_email_resolution(id:any): Promise<any> {
        return this.api.post(`${path}/${id}/send_email_resolution`);
    }
    static uploadMeetingFile(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/upload-meeting-file`, body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }
    static uploadMeetingParticipantFile(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/upload-meeting-participant-file`, body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }
    static uploadMeetingAgendaFile(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/upload-meeting-agenda-file`, body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }
    static postCoordinators(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/coordinators`, body);
    }
    static postParticipants(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/participants`, body);
    }
    static postAgendas(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/agendas`, body);
    }
    static checkPassword(body: any, id: any): Promise<any> {
        return this.api.post(`/my-meeting/${id}/check-password`, body);
    }
    static patch(body: any, id: any): Promise<any> {
        return this.api.patch(`${path}/${id}`, body);
    }
    static patchCoordinators(body: any, id: any, id_coordinator: any): Promise<any> {
        return this.api.patch(`${path}/${id}/coordinators/${id_coordinator}`, body);
    }
    static patchParticipants(body: any, id: any, id_participant: any): Promise<any> {
        return this.api.patch(`${path}/${id}/participants/${id_participant}`, body);
    }
    static patchAgendas(body: any, id: any, id_agenda: any): Promise<any> {
        return this.api.patch(`${path}/${id}/agendas/${id_agenda}`, body);
    }
    static findById(id: any): Promise<any> {
        return this.api.get(`${path}/${id}`);
    }
    static delete(id: any): Promise<any> {
        return this.api.delete(`${path}/${id}`);
    }
    static deleteCoordinators(id: any, id_coordinator: any): Promise<any> {
        return this.api.delete(`${path}/${id}/coordinators/${id_coordinator}`);
    }
    static deleteParticipants(id: any, id_participant: any): Promise<any> {
        return this.api.delete(`${path}/${id}/participants/${id_participant}`);
    }
    static deleteAgenda(id: any, id_agenda: any): Promise<any> {
        return this.api.delete(`${path}/${id}/agendas/${id_agenda}`);
    }
}